
//Représente les paramètres de mise à jour du marquage « à refuser » des factures d’achat (SU #117809)
//  La liste porte les lignes cochées de la grille, à défaut la ligne au focus. Elle ne peut pas
//  être vide : la route la refuse, et le menu est grisé sans sélection.
//  L’état cible est explicite et s’applique à toute la sélection — un basculement ligne par ligne
//  sur des lignes de marquages mêlés donnerait un résultat imprévisible pour l’utilisateur.
export class AeFMettreAJourRefusFacturesAchatParametres
{
  //Identifiants des factures sélectionnées dans la grille
  public identifiantsFactures!: string[];

  //Vrai pour marquer les factures « à refuser », faux pour annuler le marquage
  public refuser!: boolean;
}

//Représente une facture écartée par la mise à jour du marquage, et son motif (SU #117809)
export class AeFFactureAchatEcarteeRefus
{
  //Numéro de la facture, tel qu’il apparaît dans la grille des achats
  public numero!: string;

  //Motif pour lequel la facture a été écartée
  public motif!: string;
}

//Représente le résultat de la mise à jour du marquage « à refuser » des factures d’achat (SU #117809)
export class AeFMettreAJourRefusFacturesAchatResultat
{
  //Création
  constructor ()
  {
    this.nombreFacturesModifiees = 0;
    this.nombreFacturesInchangees = 0;
    this.facturesEcartees = [];
  }

  //Nombre de factures dont le marquage a été modifié
  public nombreFacturesModifiees: number;

  //Nombre de factures déjà dans l’état demandé
  public nombreFacturesInchangees: number;

  //Factures que le traitement n’a pas pu traiter, et le motif de chacune
  public facturesEcartees: AeFFactureAchatEcarteeRefus[];
}
